import React, { useState } from 'react';

function Advantages({ language = 'en' }) {
  const [activeDetail, setActiveDetail] = useState(null);

  const advantages = [
    {
      id: 'diversified-expertise',
      title: { en: 'Diversified Expertise', ar: 'خبرات متنوّعة' },
      description: {
        en: 'A multidisciplinary portfolio spanning industrial development, construction, IT solutions, event management, and consulting — allowing us to deliver integrated, end-to-end business solutions.',
        ar: 'محفظة متعددة التخصصات تشمل التطوير الصناعي، والإنشاءات، وحلول تقنية المعلومات، وإدارة الفعاليات، والاستشارات – مما يمكّننا من تقديم حلول أعمال متكاملة من البداية حتى النهاية'
      },
      image: '/img/Jpegs for website-01.jpg',
      details: {
        en: 'A multidisciplinary portfolio spanning industrial development, construction, IT solutions, event management, and consulting — allowing us to deliver integrated, end-to-end business solutions tailored to our clients\' needs.',
        ar: 'محفظة متعددة التخصصات تشمل التطوير الصناعي، والإنشاءات، وحلول تقنية المعلومات، وإدارة الفعاليات، والاستشارات – مما يمكّننا من تقديم حلول أعمال متكاملة من البداية حتى النهاية بما يلائم احتياجات عملائنا'
      }
    },
    {
      id: 'strategic-market-insight',
      title: { en: 'Strategic Market Insight', ar: 'رؤية استراتيجية للسوق' },
      description: {
        en: 'Deep understanding of the Saudi market, regulatory landscape, and economic transformation initiatives under Vision 2030, enabling us to align client strategies with national priorities.',
        ar: 'فهم عميق للسوق السعودي، والأنظمة التنظيمية، ومبادرات التحوّل الاقتصادي ضمن رؤية 2030، مما يتيح لنا مواءمة استراتيجيات العملاء مع الأولويات الوطنية'
      },
      image: '/img/Jpegs for website-02.jpg',
      details: {
        en: 'Deep understanding of the Saudi market, regulatory landscape, and economic transformation initiatives under Vision 2030, enabling us to align client strategies with national priorities.',
        ar: 'فهم عميق للسوق السعودي، والبيئة التنظيمية، ومبادرات التحوّل الاقتصادي ضمن رؤية 2030، مما يتيح لنا مواءمة استراتيجيات عملائنا مع الأولويات الوطنية'
      }
    },
    {
      id: 'strong-partnership-network',
      title: { en: 'Strong Partnership Network', ar: 'شبكة شراكات قوية' },
      description: {
        en: 'Established relationships with key private, governmental, and non-profit entities, facilitating collaboration and access to new opportunities.',
        ar: 'علاقات راسخة مع جهات خاصة وحكومية وغير ربحية، مما يسهل التعاون ويفتح آفاقًا لفرص جديدة'
      },
      image: '/img/Jpegs for website-03.jpg',
      details: {
        en: 'Over the years, Al-Jabriyah has cultivated trusted relationships with leading private companies, governmental institutions, and non-profit organizations. These strategic partnerships unlock resources, simplify coordination, and open the door to new business opportunities.',
        ar: 'على مر السنين، بنت الجبرية علاقات موثوقة مع شركات خاصة رائدة، وجهات حكومية، ومنظمات غير ربحية. وتفتح هذه الشراكات الاستراتيجية المجال للوصول إلى الموارد وتسهيل التنسيق وخلق فرص أعمال جديدة'
      }
    },
    {
      id: 'commitment-to-innovation',
      title: { en: 'Commitment to Innovation', ar: 'التزام بالابتكار' },
      description: {
        en: 'Continuous investment in technology, talent, and modern business practices to ensure agility and competitiveness in a rapidly evolving marketplace.',
        ar: 'استثمار مستمر في التكنولوجيا والكوادر البشرية والممارسات الحديثة لضمان المرونة والتنافسية في سوق سريع التغيّر'
      },
      image: '/img/Jpegs for website-04.jpg',
      details: {
        en: 'Innovation sits at the core of our operations. Al-Jabriyah invests continuously in modern technologies, top-tier talent, and advanced business practices to maintain agility and competitiveness in today\'s fast-changing world.',
        ar: 'الابتكار في صميم عملياتنا. تستثمر الجبرية بشكل مستمر في التقنيات الحديثة والكفاءات المتميزة والممارسات الإدارية المتقدمة للحفاظ على المرونة والتنافسية في عالم سريع التغيّر'
      }
    },
    {
      id: 'client-centric-approach',
      title: { en: 'Client-Centric Approach', ar: 'نهج يرتكز على العميل' },
      description: {
        en: 'Tailored solutions developed through close collaboration, ensuring alignment with each client\'s vision, objectives, and operational realities.',
        ar: 'حلول مصمَّمة بالتعاون الوثيق مع العميل لضمان توافقها مع رؤيته وأهدافه وواقعه التشغيلي'
      },
      image: '/img/Jpegs for website-08.jpg',
      details: {
        en: 'At Al-Jabriyah, our solutions begin with understanding the client\'s vision, objectives, and operational challenges. Every service we provide is tailored to meet the unique needs of each organization — from planning to execution and long-term support.',
        ar: 'في الجبرية، تبدأ حلولنا من فهم رؤية العميل وأهدافه وتحدياته التشغيلية. كل خدمة نقدّمها يتم تصميمها لتناسب احتياجات كل جهة، من مرحلة التخطيط إلى التنفيذ والدعم طويل الأمد'
      }
    }
  ];

  if (activeDetail) {
    const advantage = advantages.find(a => a.id === activeDetail);
    if (advantage) {
      return (
        <div id={advantage.id} className="target-page is-active">
          <h2>{advantage.title[language]}</h2>
          <p>{advantage.details[language]}</p>
          <button 
            className="back-btn back-adv"
            onClick={() => setActiveDetail(null)}
          >
            {language === 'ar' ? 'الرجوع إلى المميزات' : 'Back to Advantages'}
          </button>
        </div>
      );
    }
  }

  return (
    <section className="advantages" id="why-us">
      <h2>
        {language === 'ar' ? 'مميزاتنا ' : 'OUR '}
        <span>{language === 'ar' ? 'الرئيسية' : 'ADVANTAGES'}</span>
      </h2>

      <p className="adv-desc">
        {language === 'ar' 
          ? 'تتميّز الجبرية بسجل ثابت من النمو الاستراتيجي، والكفاءة التشغيلية، والخبرة متعددة القطاعات، بُنيت على أكثر من ثلاثة عقود من النجاح'
          : 'Al-Jabriyah distinguishes itself through a proven record of strategic growth, operational excellence, and cross-sector expertise built over more than three decades of success.'
        }
      </p>

      <div className="adv-container">
        {advantages.map((advantage) => (
          <div 
            key={advantage.id}
            className="adv-box"
            onClick={() => setActiveDetail(advantage.id)}
          >
            <img src={advantage.image} alt={advantage.title[language]} />
            <h3>{advantage.title[language]}</h3>
            <p>{advantage.description[language]}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Advantages;